var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['l-ss-c-tag-checkbox', { 'is-checked': _vm.isChecked }],on:{"click":function($event){return _vm.onToggle($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }